export default [
  {
    path: 'sponsorship-media',
    meta: {
      title: 'Sponsorship Media',
      auth: ['Admin', 'Super Admin'],
      hidden: false
    },
    component: () => import('./pages/index'),
    redirect: 'sponsorship-media/list',
    children: [
      {
        path: 'list',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'List',
          resource: 'sponsorshipMedia',
          icon: 'playlist_add_check',
          hidden: false
        },
        component: () => import('./pages/list')
      },
      {
        path: 'edit/:id',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'Edit',
          resource: 'sponsorshipMedia',
          icon: 'mode_edit',
          hidden: true
        },
        component: () => import('./pages/edit')
      },
      {
        path: 'add',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'Add',
          resource: 'sponsorshipMedia',
          icon: 'add_circle_outline',
          hidden: false
        },
        component: () => import('./pages/add')
      }
    ]
  }
]
